require('./searchDropDownController');

"use strict";

angular.module('app.shared.searchdDropDown.searchDropDownDirective', [
  'app.shared.searchDropdown.searchDropdownController'
])
  .directive('searchDropdown', [
    () => {
      return {
        templateUrl: 'components/shared/searchDropDown/searchDropDownView.html',
        restrict: 'AE',
        controller: 'app.shared.searchDropdown.searchDropdownController',
        controllerAs: 'controller',
        scope: {
          displayAttr: '@',
          selectedItems: '=',
          allItems: '=',
          readOnly: '=',
          idType: '=',
          addItem: '&?',
          removeItem: '&?',
          removeAll: '&?',
          dropdownWidth: '@?',
          selectAllOption: '=?',
          grouping: '=?',
          groupingLabel: '@?',
          sortDirection: '@?',
          sortBy: '@?',
          callBack: '&?',
          singleOption: '@?'
        },
        link: function(scope, element, attrs) {
          element.bind('click', function (e) {
            e.stopPropagation();
          });
        }
      }
    }]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/searchDropDown/searchDropDownDirective.js